import { z } from 'zod';
import { email } from './common.js';
import { SupplierCompliance } from '../types/enums.js';
export const supplierContactSchema = z.object({
    id: z.string().uuid().optional(),
    name: z.string().min(1),
    role: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    email: z.union([email, z.literal('')]).nullable().optional(),
});
export const createSupplierSchema = z.object({
    name: z.string().min(1).max(200),
    category: z.string().min(1),
    tags: z.array(z.string()).default([]),
    address: z.string().nullable().optional(),
    phone: z.string().nullable().optional(),
    email: z.union([email, z.literal('')]).nullable().optional(),
    compliance: z.nativeEnum(SupplierCompliance).default(SupplierCompliance.pending),
    visibility: z.enum(['internal', 'restricted']).default('internal'),
    contacts: z.array(supplierContactSchema).default([]),
});
export const updateSupplierSchema = createSupplierSchema.partial();
export const supplierQuerySchema = z.object({
    search: z.string().optional(),
    category: z.string().optional(),
    compliance: z.nativeEnum(SupplierCompliance).optional(),
});
//# sourceMappingURL=supplier.js.map